module.exports = __webpack_public_path__ + "static/media/Header-logo.57fbc096.png";